import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { teacherGet } from "../../../services/teacher";

const corporateExperienceObj = {
  position: "",
  organizationName: "",
  subjectOrResponsibilities: "",
  from: "",
  to: "",
};
const educationObj = {
  degree: "",
  collegeOrUniversity: "",
  GPAOrGradeOrDivision: "",
  passingYear: "",
  subjects: "",
};

const academicExperienceObj = {
  position: "",
  organizationName: "",
  subjectOrResponsibilities: "",
  from: "",
  to: "",
};

const areasObj = {
  country: "",
  province: "",
  city: "",
  area: "",
};

export const fetchTeacherData = createAsyncThunk(
  "teacherData/fetchContent",
  async (user) => {
    try {
      if (user?.role !== "teacher") {
        return;
      }
      const { status, data } = await teacherGet(user?.id);
      if (status === 200) {
        let backendData = data?.data;
        return {
          teacherId: user?.id,
          fullName: user?.fullName,
          email: user?.email,
          // teacherCorporateExperiences: [{ ...corporateExperienceObj }],
          // teacherEducations: [{ ...educationObj }],
          // teacherAcademicExperiences: [{ ...academicExperienceObj }],
          // areas: [{ ...areasObj }],
          ...backendData,
        };
      } else {
        toast.error(data?.message);
      }
    } catch (error) {}
  }
);
